import { combineLatest, type Observable } from 'rxjs';
import type { MetaModel } from '@ardoq/api-types';
import {
  featureOperations,
  Features,
  type FeatureContext,
} from '@ardoq/features';
import { spreadMap } from '@ardoq/rxbeach';
import type { AiControlledCommand } from 'aiControlledCommands/types';
import { selectedModule$ } from 'appContainer/selectedModule$';
import { AppModules, type PayloadShowAppModule } from 'appContainer/types';
import { featureContext$ } from 'streams/featureContext$';
import { loadedState$ } from 'loadedState/loadedState$';
import type { LoadedStatesState } from 'loadedState/loadedStateOperations';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { buildBuildViewDatasetCommand } from './buildViewDataset/command';
import { constructedTraversal$ } from './constructedTraversal$';
import { loadedMetamodel$ } from './loadedMetamodel$';
import type { PseudoTraversal } from './types';

const createTraversalBuildingCommands = (
  featureContext: FeatureContext,
  metaModel: MetaModel,
  { loadedStates }: LoadedStatesState,
  { isViewpointMode }: { isViewpointMode: boolean },
  { selectedModule }: PayloadShowAppModule,
  constructedTraversal: PseudoTraversal | null
): AiControlledCommand[] =>
  featureOperations.hasFeature(
    featureContext,
    Features.AI_TMP_TRAVERSAL_BUILDING
  )
    ? [
        buildBuildViewDatasetCommand(
          metaModel,
          isViewpointMode && selectedModule === AppModules.WORKSPACES
            ? loadedStates
            : [],
          constructedTraversal
        ),
      ]
    : [];

export const availableCommands$: Observable<AiControlledCommand[]> =
  combineLatest([
    featureContext$,
    loadedMetamodel$,
    loadedState$,
    isViewpointMode$,
    selectedModule$,
    constructedTraversal$,
  ]).pipe(spreadMap(createTraversalBuildingCommands));
